import * as React from 'react';

const SvgTrendUpArrow = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox={'0 0 11 21'}
    {...props}
  >
    <path
      d='M4.91934 0.240597C4.91909 0.240843 4.91881 0.241049 4.91856 0.241337L0.652934 4.52763C0.333381 4.84874 0.334571 5.36812 0.655723 5.68776C0.976834 6.00735 1.49622 6.00612 1.81581 5.68501L4.67968 2.80719L4.67968 20.1797C4.67968 20.6327 5.04694 21 5.5 21C5.95306 21 6.32031 20.6327 6.32031 20.1797L6.32031 2.80723L9.18418 5.68497C9.50378 6.00608 10.0232 6.00731 10.3443 5.68772C10.6655 5.36808 10.6666 4.84866 10.3471 4.52759L6.08143 0.241295C6.08119 0.241049 6.0809 0.240843 6.08065 0.240556C5.75999 -0.0807192 5.23893 -0.0796931 4.91934 0.240597Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgTrendUpArrow;
